import { render, staticRenderFns } from "./AboutBoard.vue?vue&type=template&id=2dd4cd81&scoped=true&"
import script from "./AboutBoard.vue?vue&type=script&lang=js&"
export * from "./AboutBoard.vue?vue&type=script&lang=js&"
import style0 from "./AboutBoard.vue?vue&type=style&index=0&id=2dd4cd81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4cd81",
  null
  
)

export default component.exports